var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61308 5.60097C1.61308 5.60097 6.03584 3.78587 7.56973 3.14673C8.15774 2.89109 10.1518 2.07299 10.1518 2.07299C10.1518 2.07299 11.0722 1.7151 10.9955 2.5843C10.9699 2.94222 10.7654 4.19489 10.5609 5.54985C10.2541 7.46724 9.92172 9.56355 9.92172 9.56355C9.92172 9.56355 9.87059 10.1516 9.43599 10.2538C9.00139 10.3561 8.28554 9.89593 8.15774 9.79364C8.05545 9.71697 6.24035 8.56652 5.57566 8.00409C5.3967 7.85071 5.19219 7.54395 5.60121 7.18602C6.52157 6.34237 7.62086 5.29421 8.28554 4.62952C8.59234 4.32272 8.8991 3.60691 7.62086 4.47611C5.80575 5.72881 4.0162 6.9048 4.0162 6.9048C4.0162 6.9048 3.60715 7.16044 2.8402 6.93035C2.07323 6.70029 1.17845 6.3935 1.17845 6.3935C1.17845 6.3935 0.564924 6.01003 1.61308 5.60097Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramS);
export default __webpack_public_path__ + "static/media/telegram-s.15735d23990d30a684f32ab748ba48ac.svg";
export { ForwardRef as ReactComponent };